/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { use, withMemo } from 'fierry/react';

import Route from 'solis/route';


const getConfigEntry = (value) =>
{
  if (typeof value === 'function')
  {
    return { slots: {}, component: value, stack: [] };
  }

  const { layout, ...slots } = value;

  return { slots, component: layout.at(-1), stack: layout.slice(0, -1) };
}


export default withMemo(({ config, fallback: Fallback }) =>
{
  const route = use(Route);

  if (config[route.type] == null)
  {
    return Fallback ? <Fallback /> : null;
  }

  const { component: Component, slots, stack } = getConfigEntry(config[route.type]);

  const applyLayout = (children, Layout) =>
  {
    return <Layout>{children}</Layout>;
  };

  return stack.reduceRight(applyLayout, <Component {...slots} />);
});
